import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-product-search',
  templateUrl: './product-search.component.html',
  styleUrls: ['./product-search.component.less']
})
export class ProductSearchComponent implements OnInit {

  searchContent: string = "";

  showResult: boolean = false;

  productList: string[] = [];

  @Output() searchByPartNo = new EventEmitter<string>();
  constructor(private message: NzMessageService) { }
  ngOnInit(): void {
  }

  onHandleSearch(): void {
    if (this.searchContent === '') {
      this.message.create('warning', '请输入博世号/原厂信息');
    } else {
      this.searchByPartNo.emit(this.searchContent);
      this.showResult = true;
    }
  }

  clearSearchContent() {
    this.searchContent = '';
  }
}
